module.exports = __webpack_public_path__ + "img/mori.f29d85d4.jpg";